<app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

<!-- <div *ngif="validateEmailFailed">Email Validation Failed</div> -->